export default __webpack_public_path__ + "static/media/ic_location_sm_gray.0d6ca04d.svg";